import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

const dashboardDataCache = new Map();
const dashboardRequestCache = new Map();

export const getBradescardDashboardData = async (
  agenteUuid,
  { force = false } = {}
) => {
  if (!agenteUuid) {
    throw new Error("agenteUuid es requerido");
  }

  if (force) {
    dashboardDataCache.delete(agenteUuid);
    dashboardRequestCache.delete(agenteUuid);
  }

  if (dashboardDataCache.has(agenteUuid)) {
    return dashboardDataCache.get(agenteUuid);
  }

  if (dashboardRequestCache.has(agenteUuid)) {
    return dashboardRequestCache.get(agenteUuid);
  }

  const request = mainAxios
    .get(`/v1/bradescard/dashboard/data/${agenteUuid}`, getDefaultHeaders())
    .then((response) => {
      dashboardDataCache.set(agenteUuid, response.data);
      dashboardRequestCache.delete(agenteUuid);
      return response.data;
    })
    .catch((error) => {
      dashboardRequestCache.delete(agenteUuid);
      throw new Error(getErrorMessage(error));
    });

  dashboardRequestCache.set(agenteUuid, request);
  return request;
};

export const clearBradescardDashboardDataCache = (agenteUuid) => {
  if (agenteUuid) {
    dashboardDataCache.delete(agenteUuid);
    dashboardRequestCache.delete(agenteUuid);
    return;
  }

  dashboardDataCache.clear();
  dashboardRequestCache.clear();
};
